var map = {
	"./AppleSlice.png": 68140,
	"./Cherries.png": 40717,
	"./CoffeeBeans.png": 28761,
	"./CrushedIce.png": 69769,
	"./HalfaPassionFruit.png": 47199,
	"./LemonWedge.png": 92181,
	"./LemonWheel.png": 3680,
	"./LimeWedge.png": 56741,
	"./LimeWheel.png": 91088,
	"./MintLeaf.png": 81270,
	"./MintSprig.png": 43961,
	"./OrangeWedge.png": 27570,
	"./OrangeWheel.png": 10875,
	"./Pineapple.png": 55230,
	"./Pineapple_Leaf_Stalk.png": 55967,
	"./Pomegranates.png": 6098,
	"./Raspberry.png": 37238,
	"./Strawberry.png": 21149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75520;